import { render, staticRenderFns } from "./posSalesDetailsList.vue?vue&type=template&id=03de6f51&"
import script from "./posSalesDetailsList.vue?vue&type=script&lang=js&"
export * from "./posSalesDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports